module.exports = __webpack_public_path__ + "img/2026_MRC_Symposium_SG.d067d5a6.jpg";